import WebScrapers from "./webscrapers";

const SchedulerService = {
  WebScrapers: new WebScrapers(),
} 

export default SchedulerService;